// src/pages/NotFoundPage.js
import React from 'react';
import { Link } from 'react-router-dom';
import { Layout, Result, Button, Typography } from 'antd';
import { Helmet } from 'react-helmet-async';
import { Space } from 'antd'; // Import Ant Design components

const { Content } = Layout;
const { Title } = Typography;
const { Paragraph } = Typography;

const NotFoundPage = () => {
    return (
        <div className="not-found-page" style={{ padding: '40px 20px', textAlign: 'center' }}>
            <Helmet>
                <title>404 - Seite nicht gefunden | Snus Finder</title>
                <meta name="description" content="Die gesuchte Seite konnte nicht gefunden werden." />
                {/* Add noindex to prevent search engines from indexing the 404 page */}
                <meta name="robots" content="noindex, follow" />
            </Helmet>

            <Result
                status="404"
                title="404"
                subTitle="Entschuldigung, die von Ihnen gesuchte Seite existiert leider nicht oder wurde verschoben."
                extra={
                    <Space wrap>
                        <Button type="primary">
                            <Link to="/">Zur Startseite</Link>
                        </Button>
                        <Button>
                            <Link to="/shops">Shops durchsuchen</Link>
                        </Button>
                    </Space>
                }
                style={{ paddingBottom: '40px' }}
            />

            <div className="not-found-suggestions" style={{ maxWidth: '600px', margin: '0 auto' }}>
                <Title level={4}>Vielleicht interessiert Sie auch:</Title>
                <Space direction="vertical" align="center">
                    <Typography.Link>
                        <Link to="/about">Über Snus erfahren</Link>
                    </Typography.Link>
                    <Typography.Link>
                        <Link to="/register">Ihren Shop registrieren</Link>
                    </Typography.Link>
                    <Typography.Link>
                        <Link to="/contact">Kontakt zum Support</Link>
                    </Typography.Link>
                </Space>
            </div>
        </div>
    );
};

export default NotFoundPage;